import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../theme';

// Подпись над полем — заглавными и в разрядку, как в макете платформы.
const useStyles = makeStyles({
  wrap: {
    marginBottom: 18,
  },
  label: {
    display: 'block',
    color: colors.textDim,
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    marginBottom: 7,
  },
  hint: {
    display: 'block',
    color: colors.textDim,
    fontSize: '11.5px',
    marginTop: 6,
  },
  error: {
    display: 'block',
    color: colors.red,
    fontSize: '11.5px',
    marginTop: 6,
  },
});

function FieldLabel(props) {
  const classes = useStyles();
  const { label, hint, error, children } = props;

  return (
    <div className={classes.wrap}>
      <span className={classes.label}>{label}</span>
      {children}
      {error ? <span className={classes.error}>{error}</span> : null}
      {!error && hint ? <span className={classes.hint}>{hint}</span> : null}
    </div>
  );
}

export default FieldLabel;
